/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppTimelineV3RouteImport } from './routes/_app/timeline-v3'
import { Route as AppTimelineV2RouteImport } from './routes/_app/timeline-v2'
import { Route as AppTimelineRouteImport } from './routes/_app/timeline'
import { Route as AppPlannerRouteImport } from './routes/_app/planner'
import { Route as AppDocsRouteImport } from './routes/_app/docs'
import { Route as AppCoverageMatrixRouteImport } from './routes/_app/coverage-matrix'
import { Route as AppBoardRouteImport } from './routes/_app/board'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppTasksIndexRouteImport } from './routes/_app/tasks/index'
import { Route as AppStakeholdersIndexRouteImport } from './routes/_app/stakeholders/index'
import { Route as AppRoadmapsIndexRouteImport } from './routes/_app/roadmaps/index'
import { Route as AppRisksIndexRouteImport } from './routes/_app/risks/index'
import { Route as AppProductsIndexRouteImport } from './routes/_app/products/index'
import { Route as AppOpenQuestionsIndexRouteImport } from './routes/_app/open-questions/index'
import { Route as AppMeetingsIndexRouteImport } from './routes/_app/meetings/index'
import { Route as AppFeedbackIndexRouteImport } from './routes/_app/feedback/index'
import { Route as AppEvaluationCriteriaIndexRouteImport } from './routes/_app/evaluation-criteria/index'
import { Route as AppDiscoveriesIndexRouteImport } from './routes/_app/discoveries/index'
import { Route as AppDeliveryTasksIndexRouteImport } from './routes/_app/delivery-tasks/index'
import { Route as AppDecisionsIndexRouteImport } from './routes/_app/decisions/index'
import { Route as AppCandidatesIndexRouteImport } from './routes/_app/candidates/index'
import { Route as AppB2cIndexRouteImport } from './routes/_app/b2c/index'
import { Route as MeetingsIdPresentRouteImport } from './routes/meetings.$id.present'
import { Route as AppTasksNewRouteImport } from './routes/_app/tasks/new'
import { Route as AppRoadmapsBranchRouteImport } from './routes/_app/roadmaps/$branch'
import { Route as AppRisksNewRouteImport } from './routes/_app/risks/new'
import { Route as AppProductsSlugRouteImport } from './routes/_app/products/$slug'
import { Route as AppMeetingsNewRouteImport } from './routes/_app/meetings/new'
import { Route as AppMeetingsIdRouteImport } from './routes/_app/meetings/$id'
import { Route as AppDiscoveriesSlugRouteImport } from './routes/_app/discoveries/$slug'
import { Route as AppDecisionsNewRouteImport } from './routes/_app/decisions/new'
import { Route as AppCandidatesCompareSummaryRouteImport } from './routes/_app/candidates/compare-summary'
import { Route as AppCandidatesCompareRouteImport } from './routes/_app/candidates/compare'
import { Route as AppCandidatesSlugRouteImport } from './routes/_app/candidates/$slug'
import { Route as AppArchitectureMapRouteImport } from './routes/_app/architecture/map'
import { Route as AppB2cFeedbackIndexRouteImport } from './routes/_app/b2c/feedback/index'
import { Route as AppMeetingsViewSlugRouteImport } from './routes/_app/meetings/view.$slug'

const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppTimelineV3Route = AppTimelineV3RouteImport.update({
  id: '/timeline-v3',
  path: '/timeline-v3',
  getParentRoute: () => AppRoute,
} as any)
const AppTimelineV2Route = AppTimelineV2RouteImport.update({
  id: '/timeline-v2',
  path: '/timeline-v2',
  getParentRoute: () => AppRoute,
} as any)
const AppTimelineRoute = AppTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => AppRoute,
} as any)
const AppPlannerRoute = AppPlannerRouteImport.update({
  id: '/planner',
  path: '/planner',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsRoute = AppDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => AppRoute,
} as any)
const AppCoverageMatrixRoute = AppCoverageMatrixRouteImport.update({
  id: '/coverage-matrix',
  path: '/coverage-matrix',
  getParentRoute: () => AppRoute,
} as any)
const AppBoardRoute = AppBoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AppRoute,
} as any)
const AppStakeholdersIndexRoute = AppStakeholdersIndexRouteImport.update({
  id: '/stakeholders/',
  path: '/stakeholders/',
  getParentRoute: () => AppRoute,
} as any)
const AppRoadmapsIndexRoute = AppRoadmapsIndexRouteImport.update({
  id: '/roadmaps/',
  path: '/roadmaps/',
  getParentRoute: () => AppRoute,
} as any)
const AppRisksIndexRoute = AppRisksIndexRouteImport.update({
  id: '/risks/',
  path: '/risks/',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsIndexRoute = AppProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AppRoute,
} as any)
const AppOpenQuestionsIndexRoute = AppOpenQuestionsIndexRouteImport.update({
  id: '/open-questions/',
  path: '/open-questions/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsIndexRoute = AppMeetingsIndexRouteImport.update({
  id: '/meetings/',
  path: '/meetings/',
  getParentRoute: () => AppRoute,
} as any)
const AppFeedbackIndexRoute = AppFeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => AppRoute,
} as any)
const AppEvaluationCriteriaIndexRoute =
  AppEvaluationCriteriaIndexRouteImport.update({
    id: '/evaluation-criteria/',
    path: '/evaluation-criteria/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDiscoveriesIndexRoute = AppDiscoveriesIndexRouteImport.update({
  id: '/discoveries/',
  path: '/discoveries/',
  getParentRoute: () => AppRoute,
} as any)
const AppDeliveryTasksIndexRoute = AppDeliveryTasksIndexRouteImport.update({
  id: '/delivery-tasks/',
  path: '/delivery-tasks/',
  getParentRoute: () => AppRoute,
} as any)
const AppDecisionsIndexRoute = AppDecisionsIndexRouteImport.update({
  id: '/decisions/',
  path: '/decisions/',
  getParentRoute: () => AppRoute,
} as any)
const AppCandidatesIndexRoute = AppCandidatesIndexRouteImport.update({
  id: '/candidates/',
  path: '/candidates/',
  getParentRoute: () => AppRoute,
} as any)
const AppB2cIndexRoute = AppB2cIndexRouteImport.update({
  id: '/b2c/',
  path: '/b2c/',
  getParentRoute: () => AppRoute,
} as any)
const MeetingsIdPresentRoute = MeetingsIdPresentRouteImport.update({
  id: '/meetings/$id/present',
  path: '/meetings/$id/present',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTasksNewRoute = AppTasksNewRouteImport.update({
  id: '/tasks/new',
  path: '/tasks/new',
  getParentRoute: () => AppRoute,
} as any)
const AppRoadmapsBranchRoute = AppRoadmapsBranchRouteImport.update({
  id: '/roadmaps/$branch',
  path: '/roadmaps/$branch',
  getParentRoute: () => AppRoute,
} as any)
const AppRisksNewRoute = AppRisksNewRouteImport.update({
  id: '/risks/new',
  path: '/risks/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsSlugRoute = AppProductsSlugRouteImport.update({
  id: '/products/$slug',
  path: '/products/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsNewRoute = AppMeetingsNewRouteImport.update({
  id: '/meetings/new',
  path: '/meetings/new',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsIdRoute = AppMeetingsIdRouteImport.update({
  id: '/meetings/$id',
  path: '/meetings/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDiscoveriesSlugRoute = AppDiscoveriesSlugRouteImport.update({
  id: '/discoveries/$slug',
  path: '/discoveries/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppDecisionsNewRoute = AppDecisionsNewRouteImport.update({
  id: '/decisions/new',
  path: '/decisions/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCandidatesCompareSummaryRoute =
  AppCandidatesCompareSummaryRouteImport.update({
    id: '/candidates/compare-summary',
    path: '/candidates/compare-summary',
    getParentRoute: () => AppRoute,
  } as any)
const AppCandidatesCompareRoute = AppCandidatesCompareRouteImport.update({
  id: '/candidates/compare',
  path: '/candidates/compare',
  getParentRoute: () => AppRoute,
} as any)
const AppCandidatesSlugRoute = AppCandidatesSlugRouteImport.update({
  id: '/candidates/$slug',
  path: '/candidates/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppArchitectureMapRoute = AppArchitectureMapRouteImport.update({
  id: '/architecture/map',
  path: '/architecture/map',
  getParentRoute: () => AppRoute,
} as any)
const AppB2cFeedbackIndexRoute = AppB2cFeedbackIndexRouteImport.update({
  id: '/b2c/feedback/',
  path: '/b2c/feedback/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsViewSlugRoute = AppMeetingsViewSlugRouteImport.update({
  id: '/meetings/view/$slug',
  path: '/meetings/view/$slug',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/board': typeof AppBoardRoute
  '/coverage-matrix': typeof AppCoverageMatrixRoute
  '/docs': typeof AppDocsRoute
  '/planner': typeof AppPlannerRoute
  '/timeline': typeof AppTimelineRoute
  '/timeline-v2': typeof AppTimelineV2Route
  '/timeline-v3': typeof AppTimelineV3Route
  '/architecture/map': typeof AppArchitectureMapRoute
  '/candidates/$slug': typeof AppCandidatesSlugRoute
  '/candidates/compare': typeof AppCandidatesCompareRoute
  '/candidates/compare-summary': typeof AppCandidatesCompareSummaryRoute
  '/decisions/new': typeof AppDecisionsNewRoute
  '/discoveries/$slug': typeof AppDiscoveriesSlugRoute
  '/meetings/$id': typeof AppMeetingsIdRoute
  '/meetings/new': typeof AppMeetingsNewRoute
  '/products/$slug': typeof AppProductsSlugRoute
  '/risks/new': typeof AppRisksNewRoute
  '/roadmaps/$branch': typeof AppRoadmapsBranchRoute
  '/tasks/new': typeof AppTasksNewRoute
  '/meetings/$id/present': typeof MeetingsIdPresentRoute
  '/b2c/': typeof AppB2cIndexRoute
  '/candidates/': typeof AppCandidatesIndexRoute
  '/decisions/': typeof AppDecisionsIndexRoute
  '/delivery-tasks/': typeof AppDeliveryTasksIndexRoute
  '/discoveries/': typeof AppDiscoveriesIndexRoute
  '/evaluation-criteria/': typeof AppEvaluationCriteriaIndexRoute
  '/feedback/': typeof AppFeedbackIndexRoute
  '/meetings/': typeof AppMeetingsIndexRoute
  '/open-questions/': typeof AppOpenQuestionsIndexRoute
  '/products/': typeof AppProductsIndexRoute
  '/risks/': typeof AppRisksIndexRoute
  '/roadmaps/': typeof AppRoadmapsIndexRoute
  '/stakeholders/': typeof AppStakeholdersIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/meetings/view/$slug': typeof AppMeetingsViewSlugRoute
  '/b2c/feedback/': typeof AppB2cFeedbackIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/board': typeof AppBoardRoute
  '/coverage-matrix': typeof AppCoverageMatrixRoute
  '/docs': typeof AppDocsRoute
  '/planner': typeof AppPlannerRoute
  '/timeline': typeof AppTimelineRoute
  '/timeline-v2': typeof AppTimelineV2Route
  '/timeline-v3': typeof AppTimelineV3Route
  '/': typeof AppIndexRoute
  '/architecture/map': typeof AppArchitectureMapRoute
  '/candidates/$slug': typeof AppCandidatesSlugRoute
  '/candidates/compare': typeof AppCandidatesCompareRoute
  '/candidates/compare-summary': typeof AppCandidatesCompareSummaryRoute
  '/decisions/new': typeof AppDecisionsNewRoute
  '/discoveries/$slug': typeof AppDiscoveriesSlugRoute
  '/meetings/$id': typeof AppMeetingsIdRoute
  '/meetings/new': typeof AppMeetingsNewRoute
  '/products/$slug': typeof AppProductsSlugRoute
  '/risks/new': typeof AppRisksNewRoute
  '/roadmaps/$branch': typeof AppRoadmapsBranchRoute
  '/tasks/new': typeof AppTasksNewRoute
  '/meetings/$id/present': typeof MeetingsIdPresentRoute
  '/b2c': typeof AppB2cIndexRoute
  '/candidates': typeof AppCandidatesIndexRoute
  '/decisions': typeof AppDecisionsIndexRoute
  '/delivery-tasks': typeof AppDeliveryTasksIndexRoute
  '/discoveries': typeof AppDiscoveriesIndexRoute
  '/evaluation-criteria': typeof AppEvaluationCriteriaIndexRoute
  '/feedback': typeof AppFeedbackIndexRoute
  '/meetings': typeof AppMeetingsIndexRoute
  '/open-questions': typeof AppOpenQuestionsIndexRoute
  '/products': typeof AppProductsIndexRoute
  '/risks': typeof AppRisksIndexRoute
  '/roadmaps': typeof AppRoadmapsIndexRoute
  '/stakeholders': typeof AppStakeholdersIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/meetings/view/$slug': typeof AppMeetingsViewSlugRoute
  '/b2c/feedback': typeof AppB2cFeedbackIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/_app/board': typeof AppBoardRoute
  '/_app/coverage-matrix': typeof AppCoverageMatrixRoute
  '/_app/docs': typeof AppDocsRoute
  '/_app/planner': typeof AppPlannerRoute
  '/_app/timeline': typeof AppTimelineRoute
  '/_app/timeline-v2': typeof AppTimelineV2Route
  '/_app/timeline-v3': typeof AppTimelineV3Route
  '/_app/': typeof AppIndexRoute
  '/_app/architecture/map': typeof AppArchitectureMapRoute
  '/_app/candidates/$slug': typeof AppCandidatesSlugRoute
  '/_app/candidates/compare': typeof AppCandidatesCompareRoute
  '/_app/candidates/compare-summary': typeof AppCandidatesCompareSummaryRoute
  '/_app/decisions/new': typeof AppDecisionsNewRoute
  '/_app/discoveries/$slug': typeof AppDiscoveriesSlugRoute
  '/_app/meetings/$id': typeof AppMeetingsIdRoute
  '/_app/meetings/new': typeof AppMeetingsNewRoute
  '/_app/products/$slug': typeof AppProductsSlugRoute
  '/_app/risks/new': typeof AppRisksNewRoute
  '/_app/roadmaps/$branch': typeof AppRoadmapsBranchRoute
  '/_app/tasks/new': typeof AppTasksNewRoute
  '/meetings/$id/present': typeof MeetingsIdPresentRoute
  '/_app/b2c/': typeof AppB2cIndexRoute
  '/_app/candidates/': typeof AppCandidatesIndexRoute
  '/_app/decisions/': typeof AppDecisionsIndexRoute
  '/_app/delivery-tasks/': typeof AppDeliveryTasksIndexRoute
  '/_app/discoveries/': typeof AppDiscoveriesIndexRoute
  '/_app/evaluation-criteria/': typeof AppEvaluationCriteriaIndexRoute
  '/_app/feedback/': typeof AppFeedbackIndexRoute
  '/_app/meetings/': typeof AppMeetingsIndexRoute
  '/_app/open-questions/': typeof AppOpenQuestionsIndexRoute
  '/_app/products/': typeof AppProductsIndexRoute
  '/_app/risks/': typeof AppRisksIndexRoute
  '/_app/roadmaps/': typeof AppRoadmapsIndexRoute
  '/_app/stakeholders/': typeof AppStakeholdersIndexRoute
  '/_app/tasks/': typeof AppTasksIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/meetings/view/$slug': typeof AppMeetingsViewSlugRoute
  '/_app/b2c/feedback/': typeof AppB2cFeedbackIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/sign-up'
    | '/board'
    | '/coverage-matrix'
    | '/docs'
    | '/planner'
    | '/timeline'
    | '/timeline-v2'
    | '/timeline-v3'
    | '/architecture/map'
    | '/candidates/$slug'
    | '/candidates/compare'
    | '/candidates/compare-summary'
    | '/decisions/new'
    | '/discoveries/$slug'
    | '/meetings/$id'
    | '/meetings/new'
    | '/products/$slug'
    | '/risks/new'
    | '/roadmaps/$branch'
    | '/tasks/new'
    | '/meetings/$id/present'
    | '/b2c/'
    | '/candidates/'
    | '/decisions/'
    | '/delivery-tasks/'
    | '/discoveries/'
    | '/evaluation-criteria/'
    | '/feedback/'
    | '/meetings/'
    | '/open-questions/'
    | '/products/'
    | '/risks/'
    | '/roadmaps/'
    | '/stakeholders/'
    | '/tasks/'
    | '/users/'
    | '/meetings/view/$slug'
    | '/b2c/feedback/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/sign-up'
    | '/board'
    | '/coverage-matrix'
    | '/docs'
    | '/planner'
    | '/timeline'
    | '/timeline-v2'
    | '/timeline-v3'
    | '/'
    | '/architecture/map'
    | '/candidates/$slug'
    | '/candidates/compare'
    | '/candidates/compare-summary'
    | '/decisions/new'
    | '/discoveries/$slug'
    | '/meetings/$id'
    | '/meetings/new'
    | '/products/$slug'
    | '/risks/new'
    | '/roadmaps/$branch'
    | '/tasks/new'
    | '/meetings/$id/present'
    | '/b2c'
    | '/candidates'
    | '/decisions'
    | '/delivery-tasks'
    | '/discoveries'
    | '/evaluation-criteria'
    | '/feedback'
    | '/meetings'
    | '/open-questions'
    | '/products'
    | '/risks'
    | '/roadmaps'
    | '/stakeholders'
    | '/tasks'
    | '/users'
    | '/meetings/view/$slug'
    | '/b2c/feedback'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/sign-up'
    | '/_app/board'
    | '/_app/coverage-matrix'
    | '/_app/docs'
    | '/_app/planner'
    | '/_app/timeline'
    | '/_app/timeline-v2'
    | '/_app/timeline-v3'
    | '/_app/'
    | '/_app/architecture/map'
    | '/_app/candidates/$slug'
    | '/_app/candidates/compare'
    | '/_app/candidates/compare-summary'
    | '/_app/decisions/new'
    | '/_app/discoveries/$slug'
    | '/_app/meetings/$id'
    | '/_app/meetings/new'
    | '/_app/products/$slug'
    | '/_app/risks/new'
    | '/_app/roadmaps/$branch'
    | '/_app/tasks/new'
    | '/meetings/$id/present'
    | '/_app/b2c/'
    | '/_app/candidates/'
    | '/_app/decisions/'
    | '/_app/delivery-tasks/'
    | '/_app/discoveries/'
    | '/_app/evaluation-criteria/'
    | '/_app/feedback/'
    | '/_app/meetings/'
    | '/_app/open-questions/'
    | '/_app/products/'
    | '/_app/risks/'
    | '/_app/roadmaps/'
    | '/_app/stakeholders/'
    | '/_app/tasks/'
    | '/_app/users/'
    | '/_app/meetings/view/$slug'
    | '/_app/b2c/feedback/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignUpRoute: typeof SignUpRoute
  MeetingsIdPresentRoute: typeof MeetingsIdPresentRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/timeline-v3': {
      id: '/_app/timeline-v3'
      path: '/timeline-v3'
      fullPath: '/timeline-v3'
      preLoaderRoute: typeof AppTimelineV3RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/timeline-v2': {
      id: '/_app/timeline-v2'
      path: '/timeline-v2'
      fullPath: '/timeline-v2'
      preLoaderRoute: typeof AppTimelineV2RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/timeline': {
      id: '/_app/timeline'
      path: '/timeline'
      fullPath: '/timeline'
      preLoaderRoute: typeof AppTimelineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/planner': {
      id: '/_app/planner'
      path: '/planner'
      fullPath: '/planner'
      preLoaderRoute: typeof AppPlannerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs': {
      id: '/_app/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof AppDocsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coverage-matrix': {
      id: '/_app/coverage-matrix'
      path: '/coverage-matrix'
      fullPath: '/coverage-matrix'
      preLoaderRoute: typeof AppCoverageMatrixRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/board': {
      id: '/_app/board'
      path: '/board'
      fullPath: '/board'
      preLoaderRoute: typeof AppBoardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks/': {
      id: '/_app/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stakeholders/': {
      id: '/_app/stakeholders/'
      path: '/stakeholders'
      fullPath: '/stakeholders/'
      preLoaderRoute: typeof AppStakeholdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/roadmaps/': {
      id: '/_app/roadmaps/'
      path: '/roadmaps'
      fullPath: '/roadmaps/'
      preLoaderRoute: typeof AppRoadmapsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/risks/': {
      id: '/_app/risks/'
      path: '/risks'
      fullPath: '/risks/'
      preLoaderRoute: typeof AppRisksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/': {
      id: '/_app/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AppProductsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/open-questions/': {
      id: '/_app/open-questions/'
      path: '/open-questions'
      fullPath: '/open-questions/'
      preLoaderRoute: typeof AppOpenQuestionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/': {
      id: '/_app/meetings/'
      path: '/meetings'
      fullPath: '/meetings/'
      preLoaderRoute: typeof AppMeetingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/feedback/': {
      id: '/_app/feedback/'
      path: '/feedback'
      fullPath: '/feedback/'
      preLoaderRoute: typeof AppFeedbackIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/evaluation-criteria/': {
      id: '/_app/evaluation-criteria/'
      path: '/evaluation-criteria'
      fullPath: '/evaluation-criteria/'
      preLoaderRoute: typeof AppEvaluationCriteriaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/discoveries/': {
      id: '/_app/discoveries/'
      path: '/discoveries'
      fullPath: '/discoveries/'
      preLoaderRoute: typeof AppDiscoveriesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/delivery-tasks/': {
      id: '/_app/delivery-tasks/'
      path: '/delivery-tasks'
      fullPath: '/delivery-tasks/'
      preLoaderRoute: typeof AppDeliveryTasksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/decisions/': {
      id: '/_app/decisions/'
      path: '/decisions'
      fullPath: '/decisions/'
      preLoaderRoute: typeof AppDecisionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/candidates/': {
      id: '/_app/candidates/'
      path: '/candidates'
      fullPath: '/candidates/'
      preLoaderRoute: typeof AppCandidatesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/b2c/': {
      id: '/_app/b2c/'
      path: '/b2c'
      fullPath: '/b2c/'
      preLoaderRoute: typeof AppB2cIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/meetings/$id/present': {
      id: '/meetings/$id/present'
      path: '/meetings/$id/present'
      fullPath: '/meetings/$id/present'
      preLoaderRoute: typeof MeetingsIdPresentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/tasks/new': {
      id: '/_app/tasks/new'
      path: '/tasks/new'
      fullPath: '/tasks/new'
      preLoaderRoute: typeof AppTasksNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/roadmaps/$branch': {
      id: '/_app/roadmaps/$branch'
      path: '/roadmaps/$branch'
      fullPath: '/roadmaps/$branch'
      preLoaderRoute: typeof AppRoadmapsBranchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/risks/new': {
      id: '/_app/risks/new'
      path: '/risks/new'
      fullPath: '/risks/new'
      preLoaderRoute: typeof AppRisksNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/$slug': {
      id: '/_app/products/$slug'
      path: '/products/$slug'
      fullPath: '/products/$slug'
      preLoaderRoute: typeof AppProductsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/new': {
      id: '/_app/meetings/new'
      path: '/meetings/new'
      fullPath: '/meetings/new'
      preLoaderRoute: typeof AppMeetingsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/$id': {
      id: '/_app/meetings/$id'
      path: '/meetings/$id'
      fullPath: '/meetings/$id'
      preLoaderRoute: typeof AppMeetingsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/discoveries/$slug': {
      id: '/_app/discoveries/$slug'
      path: '/discoveries/$slug'
      fullPath: '/discoveries/$slug'
      preLoaderRoute: typeof AppDiscoveriesSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/decisions/new': {
      id: '/_app/decisions/new'
      path: '/decisions/new'
      fullPath: '/decisions/new'
      preLoaderRoute: typeof AppDecisionsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/candidates/compare-summary': {
      id: '/_app/candidates/compare-summary'
      path: '/candidates/compare-summary'
      fullPath: '/candidates/compare-summary'
      preLoaderRoute: typeof AppCandidatesCompareSummaryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/candidates/compare': {
      id: '/_app/candidates/compare'
      path: '/candidates/compare'
      fullPath: '/candidates/compare'
      preLoaderRoute: typeof AppCandidatesCompareRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/candidates/$slug': {
      id: '/_app/candidates/$slug'
      path: '/candidates/$slug'
      fullPath: '/candidates/$slug'
      preLoaderRoute: typeof AppCandidatesSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/architecture/map': {
      id: '/_app/architecture/map'
      path: '/architecture/map'
      fullPath: '/architecture/map'
      preLoaderRoute: typeof AppArchitectureMapRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/b2c/feedback/': {
      id: '/_app/b2c/feedback/'
      path: '/b2c/feedback'
      fullPath: '/b2c/feedback/'
      preLoaderRoute: typeof AppB2cFeedbackIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/view/$slug': {
      id: '/_app/meetings/view/$slug'
      path: '/meetings/view/$slug'
      fullPath: '/meetings/view/$slug'
      preLoaderRoute: typeof AppMeetingsViewSlugRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppBoardRoute: typeof AppBoardRoute
  AppCoverageMatrixRoute: typeof AppCoverageMatrixRoute
  AppDocsRoute: typeof AppDocsRoute
  AppPlannerRoute: typeof AppPlannerRoute
  AppTimelineRoute: typeof AppTimelineRoute
  AppTimelineV2Route: typeof AppTimelineV2Route
  AppTimelineV3Route: typeof AppTimelineV3Route
  AppIndexRoute: typeof AppIndexRoute
  AppArchitectureMapRoute: typeof AppArchitectureMapRoute
  AppCandidatesSlugRoute: typeof AppCandidatesSlugRoute
  AppCandidatesCompareRoute: typeof AppCandidatesCompareRoute
  AppCandidatesCompareSummaryRoute: typeof AppCandidatesCompareSummaryRoute
  AppDecisionsNewRoute: typeof AppDecisionsNewRoute
  AppDiscoveriesSlugRoute: typeof AppDiscoveriesSlugRoute
  AppMeetingsIdRoute: typeof AppMeetingsIdRoute
  AppMeetingsNewRoute: typeof AppMeetingsNewRoute
  AppProductsSlugRoute: typeof AppProductsSlugRoute
  AppRisksNewRoute: typeof AppRisksNewRoute
  AppRoadmapsBranchRoute: typeof AppRoadmapsBranchRoute
  AppTasksNewRoute: typeof AppTasksNewRoute
  AppB2cIndexRoute: typeof AppB2cIndexRoute
  AppCandidatesIndexRoute: typeof AppCandidatesIndexRoute
  AppDecisionsIndexRoute: typeof AppDecisionsIndexRoute
  AppDeliveryTasksIndexRoute: typeof AppDeliveryTasksIndexRoute
  AppDiscoveriesIndexRoute: typeof AppDiscoveriesIndexRoute
  AppEvaluationCriteriaIndexRoute: typeof AppEvaluationCriteriaIndexRoute
  AppFeedbackIndexRoute: typeof AppFeedbackIndexRoute
  AppMeetingsIndexRoute: typeof AppMeetingsIndexRoute
  AppOpenQuestionsIndexRoute: typeof AppOpenQuestionsIndexRoute
  AppProductsIndexRoute: typeof AppProductsIndexRoute
  AppRisksIndexRoute: typeof AppRisksIndexRoute
  AppRoadmapsIndexRoute: typeof AppRoadmapsIndexRoute
  AppStakeholdersIndexRoute: typeof AppStakeholdersIndexRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppMeetingsViewSlugRoute: typeof AppMeetingsViewSlugRoute
  AppB2cFeedbackIndexRoute: typeof AppB2cFeedbackIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBoardRoute: AppBoardRoute,
  AppCoverageMatrixRoute: AppCoverageMatrixRoute,
  AppDocsRoute: AppDocsRoute,
  AppPlannerRoute: AppPlannerRoute,
  AppTimelineRoute: AppTimelineRoute,
  AppTimelineV2Route: AppTimelineV2Route,
  AppTimelineV3Route: AppTimelineV3Route,
  AppIndexRoute: AppIndexRoute,
  AppArchitectureMapRoute: AppArchitectureMapRoute,
  AppCandidatesSlugRoute: AppCandidatesSlugRoute,
  AppCandidatesCompareRoute: AppCandidatesCompareRoute,
  AppCandidatesCompareSummaryRoute: AppCandidatesCompareSummaryRoute,
  AppDecisionsNewRoute: AppDecisionsNewRoute,
  AppDiscoveriesSlugRoute: AppDiscoveriesSlugRoute,
  AppMeetingsIdRoute: AppMeetingsIdRoute,
  AppMeetingsNewRoute: AppMeetingsNewRoute,
  AppProductsSlugRoute: AppProductsSlugRoute,
  AppRisksNewRoute: AppRisksNewRoute,
  AppRoadmapsBranchRoute: AppRoadmapsBranchRoute,
  AppTasksNewRoute: AppTasksNewRoute,
  AppB2cIndexRoute: AppB2cIndexRoute,
  AppCandidatesIndexRoute: AppCandidatesIndexRoute,
  AppDecisionsIndexRoute: AppDecisionsIndexRoute,
  AppDeliveryTasksIndexRoute: AppDeliveryTasksIndexRoute,
  AppDiscoveriesIndexRoute: AppDiscoveriesIndexRoute,
  AppEvaluationCriteriaIndexRoute: AppEvaluationCriteriaIndexRoute,
  AppFeedbackIndexRoute: AppFeedbackIndexRoute,
  AppMeetingsIndexRoute: AppMeetingsIndexRoute,
  AppOpenQuestionsIndexRoute: AppOpenQuestionsIndexRoute,
  AppProductsIndexRoute: AppProductsIndexRoute,
  AppRisksIndexRoute: AppRisksIndexRoute,
  AppRoadmapsIndexRoute: AppRoadmapsIndexRoute,
  AppStakeholdersIndexRoute: AppStakeholdersIndexRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppMeetingsViewSlugRoute: AppMeetingsViewSlugRoute,
  AppB2cFeedbackIndexRoute: AppB2cFeedbackIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  SignUpRoute: SignUpRoute,
  MeetingsIdPresentRoute: MeetingsIdPresentRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
